import React from "react";
import {Timeline, Button, Radio, Input, message} from 'antd';
import './index.sass'
import api from "../../../../utils/api";

export default class Refund extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            refundOrderLogs: [],
            decisionValue: 1,
            reason: '',
            afterServiceId: props.afterServiceId,
        };
    }

    componentDidMount () {
        if (this.state.afterServiceId) {
            this.loadAfterServiceLogs();
        }
    }

    loadAfterServiceLogs () {
        api('get-order-after-service-logs-for-back', {
            order_after_service_id: this.state.afterServiceId
        }).then((res) => {
            if (res['code'] === 200) {
                this.setState({
                    refundOrderLogs: res['data'],
                })
            }
        })
    }

    shouldComponentUpdate (nextProps, nextState, nextContext) {
        if (nextProps.afterServiceId && nextProps.afterServiceId !== this.props.afterServiceId) {
            this.loadAfterServiceLogs();
            return true;
        }
        return false;
    }

    closeHandle = () => {
        this.props.colsePop()
    }

    saveHandle = async () => {
        let {decisionValue, reason} = this.state;
        let agree = decisionValue === 1;
        let param = {
            agree,
            reason,
            order_after_service_id: this.state.afterServiceId,
        }
        let res = await api('handle-order-after-service', param);
        if (res['code'] === 200) {
            message.success(res['message'])
            this.closeHandle()
        } else {
            message.error(res['message'])
        }
    }

    decision = (e) => {
        this.setState({
            decisionValue: e.target.value
        })
    }

    render () {
        let {refundOrderLogs, decisionValue, afterServiceId} = this.state;
        return afterServiceId && (
            <div className='refund'>
                <div className='close'/>
                <div className='popBox'>
                    <p className='title'>
                        待退款
                    </p>

                    <div className='popContent'>
                        <div className='popCtx'>
                            <div className='flex line alignCenter tree'>
                                <Timeline>
                                    {
                                        refundOrderLogs.map((item, index) => {
                                            return <Timeline.Item>
                                                {
                                                    item.handler.role === 'user' ? (<div>
                                                        <p>{item['handle_time']}</p>
                                                        <p>用户 {item.handler.name} 申请退款 </p>
                                                        <p>退款金额（部分退款）：¥{item['refund_total_amount']}</p>
                                                        <p>申请说明： {item.reason}</p>

                                                        <ul className='flex'>

                                                        </ul>
                                                    </div>) : null
                                                }

                                                {
                                                    item.handler.role === 'seller' ? (<div>
                                                        <p>{item['handle_time']}</p>
                                                        <p>商户 {item.handler.name} 意见</p>

                                                        <p>理由：{item.reason}</p>
                                                        <p>回复： {item['reply_reason']}</p>
                                                    </div>) : null
                                                }

                                                {
                                                    item.handler.role === 'provider' ? (<div>
                                                        <p>{item['handle_time']}</p>
                                                        <p>我 {item.handler.name} 意见</p>

                                                        <p>理由：{item.reason}</p>
                                                        <p>回复： {item['reply_reason']}</p>

                                                        <ul className='flex'>

                                                        </ul>
                                                    </div>) : null
                                                }

                                            </Timeline.Item>
                                        })
                                    }

                                    <Timeline.Item color='#adadad'>
                                        <p>我的意见</p>
                                        <Radio.Group onChange={(e) => {
                                            this.decision(e)
                                        }} value={decisionValue}>
                                            <Radio value={1}>同意</Radio>
                                            <Radio value={2}>拒绝</Radio>
                                        </Radio.Group>

                                        {
                                            decisionValue === 2 ? (
                                                <div className='line mgt20'>
                                                    <label className='mgr10'>请输入拒绝理由：</label>
                                                    <Input.TextArea onChange={(e) => {
                                                        this.setState({reason: e.target.value})
                                                    }} placeholder='请输入拒绝理由：'/>
                                                </div>
                                            ) : null
                                        }
                                    </Timeline.Item>

                                </Timeline>

                            </div>


                            <div className='flex line contrlBtn'>
                                <Button onClick={() => {
                                    this.saveHandle()
                                }} className='themeBtn mgr40'>保存</Button>
                                <Button onClick={() => {
                                    this.closeHandle()
                                }}>关闭</Button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}